import {
  DELETEVOUCHERMAPPING_SUCCESS,
  DELETEVOUCHERMAPPING_FAILED,
  RESET_DELETEVOUCHERMAPPING,
  LOADING_DELETEVOUCHERMAPPING,
  NETWORK_ERROR_DELETEVOUCHERMAPPING,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_DELETEVOUCHERMAPPING:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case DELETEVOUCHERMAPPING_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case DELETEVOUCHERMAPPING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_DELETEVOUCHERMAPPING:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_DELETEVOUCHERMAPPING:
      return (state = initialState);
    default:
      return state;
  }
};
